<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<div class="header" [hidden]="isLoading">
    <div class="header-filters">
        <mat-form-field class="search-input">
            <i matPrefix class="tce-icon-search"></i>
            <input matInput
                (keyup)="filter($event.target.value);"
                [value]="searchCriteria"
                (input)="searchCriteria = $event.target.value"
                [placeholder]="'brand.grid.search' | translate">
        </mat-form-field>
        <mat-form-field class="reseller-filter" *ngIf="showResellerFilter">
            <input #resellerFilterInput
                   matInput
                   type="text"
                   [value]="resellerFilterInput.value"
                   *ngIf="resellerSelect.panelOpen"
                   [placeholder]="resellerInputFocused ? ('brand.grid.reseller' | translate) : null"
                   (input)="filteredResellers = filterItems(resellerFilterInput.value, resellers, 'name')"
                   (focus)="resellerInputFocused = true"
                   (blur)="resellerInputFocused = false">
            <!-- Hide mat-select when input is focused -->
            <mat-select matInput
                        #resellerSelect
                        panelClass="custom-autocomplete-select reseller-select"
                        [ngClass]="{ 'hidden-select': resellerSelect.panelOpen }"
                        disableOptionCentering
                        class="reseller-select"
                        [(ngModel)]="selectedReseller"
                        [placeholder]="selectedReseller ? selectedReseller.name : ('brand.grid.reseller' | translate)"
                        (selectionChange)="onResellerSelected($event.value)"
                        (closed)="resetFilteredResellers()">
                <mat-option *ngFor="let reseller of filteredResellers"
                            [value]="reseller"
                            class="option">
                    {{ reseller.name }}
                </mat-option>
            </mat-select>
            <button *ngIf="selectedReseller" matSuffix mat-icon-button aria-label="Clear" (click)="clearResellerSelection($event)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="header-actions">
        <txp-button
           *ngIf="canCreateBrand$ | async"
           data-qa-label="CreateButton"
           [style]="buttonStyle.PRIMARY"
           [size]="buttonSize.SMALL"
           (click)="createBrand($event)"
           [loading]="loading">
           {{'brand.grid.createBrand' | translate}}
       </txp-button>
    </div>
</div>

<div class="table-content">
    <table mat-table
           [dataSource]="dataSource"
           matSort
           matSortActive="name"
           matSortDirection="asc"
           matSortDisableClear
           [hidden]="isLoading">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'brand.grid.name' | translate}}</th>
            <td mat-cell *matCellDef="let brand">
                <a class="edit-link"
                    (click)="setBrand(brand)"
                    [attr.title]="'form.button.edit' | translate"
                    data-qa-label="EditLink"
                    href="javascript:void(0);">
                    {{ brand.name }}
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="countryCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'brand.grid.country' | translate}}</th>
            <td mat-cell *matCellDef="let brand"> {{ brand.countryCode }} </td>
        </ng-container>

        <ng-container matColumnDef="alias">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'brand.grid.alias' | translate}}</th>
            <td mat-cell *matCellDef="let brand"> {{ brand.alias }} </td>
        </ng-container>

        <ng-container matColumnDef="reseller" *ngIf="showResellerFilter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'brand.grid.reseller' | translate}}</th>
            <td mat-cell *matCellDef="let brand"> {{ getResellerName(brand.resellerId) }} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="numberOfStores">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> # of Stores </th>
        <td mat-cell *matCellDef="let brand"> {{ brand.numberOfStores }} </td>
        </ng-container>

        <ng-container matColumnDef="posType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> POS Type </th>
        <td mat-cell *matCellDef="let brand"> {{ brand.posType }} </td>
        </ng-container> -->

        <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading> {{ 'brand.grid.loading' | translate}}

        <!-- footer for "still loading" message -->
        <ng-container matColumnDef="loading">
            <td mat-footer-cell *matFooterCellDef colspan="100">
                <div>
                    <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
                    {{ 'brand.grid.loading' | translate}}
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="['loading']; sticky: true" [hidden]="!isStillLoading"></tr>
    </table>
</div>
